var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-dialog",
        {
          attrs: {
            "append-to-body": true,
            "before-close": _vm.handleClose,
            fullscreen: true,
            title: _vm.fromData.title,
            visible: _vm.dialogVisible,
            width: _vm.fromData.width,
            top: "0",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
          },
        },
        [_c("iframe", { staticClass: "iframe", attrs: { src: _vm.fileUrl } })]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }